import * as OrgConfig from "src/generated/hooks/org-config/requests";
import * as RD from "src/types/remoteData";
import { DeepReadonly } from "src/types/utils";
import { useOrgConfig } from "./useOrgConfig";

const DefaultConfig = OrgConfig.LoginConfigSchema.default;

export function useLoginMethods(
  pathType: "admin" | "parent"
): RD.RemoteData<unknown, readonly DeepReadonly<OrgConfig.LoginMethod>[]> {
  return useOrgConfig<OrgConfig.LoginConfig>("Login", DefaultConfig).map(
    (config) => (pathType === "admin" ? config.admin : config.parent)
  );
}
